'use strict';

exports.__esModule = true;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

exports.getMenu = getMenu;
exports.getSections = getSections;
exports.getSection = getSection;
exports.getProducts = getProducts;
exports.enableProduct = enableProduct;
exports.disableProduct = disableProduct;
exports.enableSection = enableSection;
exports.disableSection = disableSection;

var _quCheck = require('../utils/qu-check');

var _apiClient = require('../network/api-client');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var API = {
  CUSTOMER_MENU: '/customer/menus'
};

var menu = {
  getMenu: getMenu,
  getSection: getSection,
  getSections: getSections,
  getProducts: getProducts,
  enableProduct: enableProduct,
  disableProduct: disableProduct,
  enableSection: enableSection,
  disableSection: disableSection
};

exports.default = menu;

/**
 * Get a menu helper
 * @param menuId : number
 * @returns {menu} containing customer menu id
 */

function getMenu(_ref) {
  var menuId = _ref.menuId;

  return (0, _apiClient.get)({ route: API.CUSTOMER_MENU + '/' + menuId });
}

/**
 * Get menu sections
 * @param menuId : number
 * @returns {menu} containing the requested section of menu
 */
function getSections(_ref2) {
  var menuId = _ref2.menuId;

  return (0, _apiClient.get)({ route: API.CUSTOMER_MENU + '/' + menuId + '/sections' });
}

/**
 * Get a section
 * @param menuId : number
 * @param sectionId : number
 * @returns {menu} containing the requested section details
 */
function getSection(_ref3) {
  var menuId = _ref3.menuId,
      sectionId = _ref3.sectionId;

  return (0, _apiClient.get)({ route: API.CUSTOMER_MENU + '/' + menuId + '/sections/' + sectionId });
}

/**
 * Get products
 * @param menuId : number
 * @param sectionId : number
 * @param resultsPerPage : number
 * @returns {menu} containing products belonging to the requested section
 */
function getProducts(_ref4) {
  var menuId = _ref4.menuId,
      sectionId = _ref4.sectionId,
      _ref4$resultsPerPage = _ref4.resultsPerPage,
      resultsPerPage = _ref4$resultsPerPage === undefined ? 15 : _ref4$resultsPerPage;

  return (0, _apiClient.get)({
    route: API.CUSTOMER_MENU + '/' + menuId + '/sections/' + sectionId + '/products?page=1&per_page=' + resultsPerPage
  });
}

/**
 * PUT enable product
 * @param { menuId : number, productId : number }
 */
function enableProduct() {
  var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      menuId = _ref5.menuId,
      productId = _ref5.productId;

  return toggleProduct('enable', menuId, productId);
}

/**
 * PUT disable product
 * @param { menuId : number, productId : number }
 */
function disableProduct() {
  var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      menuId = _ref6.menuId,
      productId = _ref6.productId;

  return toggleProduct('disable', menuId, productId);
}

function toggleProduct(toggle, menuId, productId) {
  var paramsCheck = _quCheck.checker.warn(_quCheck.Menu, [{ menuId: menuId, productId: productId }]);
  if (paramsCheck.failed) {
    return new _promise2.default(function (resolve, reject) {
      reject(paramsCheck);
    });
  }
  return (0, _apiClient.put)({ route: API.CUSTOMER_MENU + '/' + menuId + '/products/' + productId + '/' + toggle });
}

/**
 * PUT enable section
 * @param { menuId : number, sectionId : number }
 */
function enableSection(_ref7) {
  var menuId = _ref7.menuId,
      sectionId = _ref7.sectionId;

  return (0, _apiClient.put)({ route: API.CUSTOMER_MENU + '/' + menuId + '/sections/' + sectionId + '/enable' });
}

/**
 * PUT disable section
 * @param { menuId : number, sectionId : number }
 */
function disableSection(_ref8) {
  var menuId = _ref8.menuId,
      sectionId = _ref8.sectionId;

  return (0, _apiClient.put)({ route: API.CUSTOMER_MENU + '/' + menuId + '/sections/' + sectionId + '/disable' });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/quiqupjs/lib/customer/menus.js
// module id = 1092
// module chunks = 0